export default __webpack_public_path__ + "static/media/gMeter.8be58b59.png";